import billingsTranslationsHelper from "../../../../../../../languages/billings-translations.helper";
import BillingsTaxiTaxiContributionsPenaltyTableColumn from "../types/billings-taxi-taxi-contributions-penalty-table-column";

const getRequiredColumnHeading = (heading: string) => (
  <>
    {heading} <span className="header_asterisk">*</span>
  </>
);

const getColumns = (): BillingsTaxiTaxiContributionsPenaltyTableColumn[] => {
  const translations =
    billingsTranslationsHelper.getTaxiTaxiContributionsTranslations().penalty
      .table.headers;

  const tableColumns: BillingsTaxiTaxiContributionsPenaltyTableColumn[] = [
    {
      header: translations.typeLabel,
      title: translations.typeTitle,
      accessor: "type",
      colSpan: 10,
    },
    {
      header: getRequiredColumnHeading(translations.amountLabel),
      title: translations.amountTitle,
      accessor: "amount",
      colSpan: 10,
    },
    {
      header: getRequiredColumnHeading(translations.commentLabel),
      title: translations.commentTitle,
      accessor: "comment",
      colSpan: 10,
    },
    {
      header: "",
      title: "",
      accessor: "actions",
      colSpan: 5,
    },
  ];

  return tableColumns;
};

const BillingsTaxiTaxiContributionsPenaltyTableHelper = { getColumns };

export default BillingsTaxiTaxiContributionsPenaltyTableHelper;
